<template>
  <el-menu :default-active="mod" router>
    <el-menu-item index="baike" :route="`/product/baike/${id}`">
      <div class="active"></div>百科信息
    </el-menu-item>
    <el-menu-item index="chain" :route="`/product/chain/${id}`">
      <div class="active"></div>供应链信息
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "product-aside",
  props: ["mod", "id"]
};
</script>

<style lang="less">
li.el-menu-item .active {
  display: inline-block;
  width: 4px;
  height: 30px;
}
li.is-active > .active {
  display: inline-block;
  width: 4px;
  height: 30px;
  background: rgba(27, 153, 79, 1);
  border-radius: 0px 5px 5px 0px;

  position: relative;

  left: -10px;
}
</style>
